import React from 'react';
import { connect } from 'react-redux';
import { Navigation } from 'next/components/Navigation';

import { requestSpoof, cancelSpoof } from 'actions/spoofing';
import { fetchOverviewAnalytics } from 'actions/analytics';
import { selectAccountFeature } from 'reducers/account/features';
import { selectIsInstalled } from 'reducers/account/installedDomains';
import { selectAccountMeta } from 'reducers/account/meta';
import { selectNavMode } from 'reducers/navigation';
import { selectUser } from 'reducers/user';
import { selectOverviewAnalytics } from 'reducers/analytics';
import { NEW_NAV } from 'constants/features';

import OldNavBar from './OldNavBar';

const Navbar = ({
  className,
  flowsShown,
  hasNewNav,
  isInstalled,
  meta,
  navMode,
  onGetOverview,
  onSpoof,
  spoofing,
  user,
}) => {
  if (hasNewNav) {
    // For now data from the old store should be passed
    // to the new Navigation until we implement the new redux in there.
    // No need to use the same prop names.
    return (
      <Navigation
        installed={isInstalled}
        user={user}
        onSpoof={onSpoof}
        spoofing={spoofing}
        accountMeta={meta}
        flowsShown={flowsShown}
        onGetOverview={onGetOverview}
      />
    );
  }

  return (
    <OldNavBar
      user={user}
      className={className}
      isInstalled={isInstalled}
      meta={meta}
      navMode={navMode}
    />
  );
};

const mapStateToProps = state => {
  const overviewAnalytics = selectOverviewAnalytics(state);
  const flowsShown = overviewAnalytics?.data?.flows_shown;

  return {
    hasNewNav: selectAccountFeature(state, NEW_NAV),
    isInstalled: selectIsInstalled(state),
    meta: selectAccountMeta(state),
    navMode: selectNavMode(state),
    spoofing: !!state.spoofing,
    user: selectUser(state),
    flowsShown,
  };
};

const mapDispatchToProps = {
  onCancelSpoof: cancelSpoof,
  onSpoof: requestSpoof,
  onGetOverview: fetchOverviewAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
